import React from 'react';
import './step-header.css';

const StepHeader = ({ title, subtitle }) => {
  return (
    <div className="step-header">
      <h2 className="step-title">{title}</h2>
      {subtitle && (
        <p 
          className="step-subtitle"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </div>
  );
};

export default StepHeader;